import React, {useEffect, useState} from 'react'
import {Routes, Route, Navigate, Outlet} from 'react-router-dom'
import LeadManagementWrapper from './LeadManagementWrapper'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import LeadManagementDashboard from './Components/LeadManagementDashboard'
import NewLeadsForm from './Components/NewLeadsForm'
import { getListLeadForm } from './LeadManagementAPI'
import Swal from 'sweetalert2'

const profileBreadCrumbs: Array<PageLink> = [
  {title: 'Lead Management', path: '/lead-dashboard', isSeparator: false, isActive: false},
  {title: '', path: '', isSeparator: true, isActive: false},
]

const LeadManagementRoute = () => {
  const [leadFormLink, setLeadFormLink] = useState<string>()

   // function to get add leads form link (jotform link)
   const getLeadFormLink = async () => {
    try {
      const {data: response} = await getListLeadForm()
      if (response.code === '200') {
        setLeadFormLink(response.data[0].yourSharableLink)
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    }
  }
  
  // onload fetch the add leads form link (jotform link)
  useEffect(()=>{
    getLeadFormLink()
  },[])
  return (
    <>
      <Routes>
        {/* Begin: main route for lead management */}
        <Route
          element={
            <>
              <LeadManagementWrapper />
              <Outlet />
            </>
          }
        >
          {/* Begin: Child route for dashboard */}
          <Route
            path='/lead-dashboard'
            element={
              <>
                <PageTitle breadcrumbs={profileBreadCrumbs}>Dashboard</PageTitle>
                <LeadManagementDashboard leadFormLink={leadFormLink}/>
              </>
            }
          />
          {/* End: Child route for dashboard */}
           {/* Begin: Child route for new_lead */}
           <Route
            path='new_lead'
            element={
              <>
                <PageTitle breadcrumbs={profileBreadCrumbs}>New Lead</PageTitle>
                <NewLeadsForm />
              </>
            }
          />
          {/* End: Child route for new_lead */}
        </Route>
        {/* End: main route for lead management */}
        <Route index element={<Navigate to={`/lead_management/lead-dashboard?page=1`} />} />
        <Route path='*' element={<Navigate to='/404' />} />
      </Routes>
    </>
  )
}

export default LeadManagementRoute
